import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { EMPTY_VALUE_FOR_TABLE } from 'common/constants/valuations';
import {
  COLUMN_DATE,
  COLUMN_PRICE,
  COLUMN_SIZE,
  COLUMN_SOURCE,
  COLUMN_TITLE,
} from 'pages/Valuations/approaches/backsolveApproach/SourceRowsTable/constants';
import { SecondaryTransactionsPreviewModalProps } from './SecondaryTransactionsPreviewModal.props';
import { TxTable, TxTableCell, TxTableHead, TxTableRow } from '../ZXIndexValueCard.styles';
import { useSecondaryTransactionsPreview } from './useSecondaryTransactionsPreview';

const SecondaryTransactionsPreviewModal = ({
  open,
  onClose,
  onAddToValuation,
  pricing,
  transactions,
  measurementDate,
}: SecondaryTransactionsPreviewModalProps) => {
  const rows = useSecondaryTransactionsPreview(pricing, transactions, measurementDate);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-testid="zx-index-card__secondary-transactions-preview-modal">
      <DialogTitle component="div">
        <Typography variant="h2" sx={{ fontWeight: 600}}>
          Secondary Transactions Preview
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ margin: '0.5rem 0'}}>
          Last 12 months ending on {measurementDate}
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ margin: '0.5rem 0'}}>
          Important: Weightings are set on the valuation page, which determines the target price per share.
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {rows.length > 0 ? (
          <TxTable>
            <thead>
              <TxTableRow>
                <TxTableHead>{COLUMN_TITLE}</TxTableHead>
                <TxTableHead>{COLUMN_DATE}</TxTableHead>
                <TxTableHead>{COLUMN_SOURCE}</TxTableHead>
                <TxTableHead>{COLUMN_SIZE}</TxTableHead>
                <TxTableHead>{COLUMN_PRICE}</TxTableHead>
              </TxTableRow>
            </thead>
            <tbody>
              {rows.map(row => (
                <TxTableRow key={row.key}>
                  <TxTableCell>{row.title}</TxTableCell>
                  <TxTableCell>{row.date ? row.date : EMPTY_VALUE_FOR_TABLE}</TxTableCell>
                  <TxTableCell>{row.source}</TxTableCell>
                  <TxTableCell>{row.size}</TxTableCell>
                  <TxTableCell>{row.pricePerShare}</TxTableCell>
                </TxTableRow>
              ))}
            </tbody>
          </TxTable>
        ) : (
          <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', textAlign: 'center', py: 3 }}>
            No secondary transactions data available for this measurement date.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} data-testid="zx-index-card__secondary-transactions-preview-cancel">
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onAddToValuation}
          data-testid="zx-index-card__secondary-transactions-preview-add">
          Add to Valuation
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecondaryTransactionsPreviewModal;
